export const AddCirclePrimaryIcon = ({
  strokeColor = "var(--color-btn-primary-active)",
  width = "30",
  height = "30",
  ...props
}: {
  strokeColor?: string;
  width?: string | number;
  height?: string | number;
  // Other props you might want to accept
}) => (
  <svg {...props} width={width} height={height} viewBox="0 0 30 30" fill="none">
    <g id="vuesax/outline/add-circle">
      <g id="add-circle">
        <path
          id="Vector"
          d="M15 28.4375C7.5875 28.4375 1.5625 22.4125 1.5625 15C1.5625 7.5875 7.5875 1.5625 15 1.5625C22.4125 1.5625 28.4375 7.5875 28.4375 15C28.4375 22.4125 22.4125 28.4375 15 28.4375ZM15 3.4375C8.625 3.4375 3.4375 8.625 3.4375 15C3.4375 21.375 8.625 26.5625 15 26.5625C21.375 26.5625 26.5625 21.375 26.5625 15C26.5625 8.625 21.375 3.4375 15 3.4375Z"
          fill={strokeColor}
        />
        <path
          id="Vector_2"
          d="M20 15.9375H10C9.4875 15.9375 9.0625 15.5125 9.0625 15C9.0625 14.4875 9.4875 14.0625 10 14.0625H20C20.5125 14.0625 20.9375 14.4875 20.9375 15C20.9375 15.5125 20.5125 15.9375 20 15.9375Z"
          fill={strokeColor}
        />
        <path
          id="Vector_3"
          d="M15 20.9375C14.4875 20.9375 14.0625 20.5125 14.0625 20V10C14.0625 9.4875 14.4875 9.0625 15 9.0625C15.5125 9.0625 15.9375 9.4875 15.9375 10V20C15.9375 20.5125 15.5125 20.9375 15 20.9375Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
